/* eslint-disable @typescript-eslint/naming-convention */
// eslint-disable-next-line no-shadow
export enum VehicleActivityType {
    TRIPTRIP = 'TRIPTRIP',
    LAYOVER = 'LAYOVER',
    PULLINTRIP = 'PULLINTRIP',
    PREPIN = 'PREPIN',
    PREPOUT = 'PREPOUT',
    PULLOUTTRIP = 'PULLOUTTRIP',
    DEADHEADTRIP = 'DEADHEADTRIP',
    TOM = 'TOM'
}

export class VehicleActivityTypeHelper {
    public static getColor(type: VehicleActivityType) {
        let activityTypeColor = '#555';
        switch (type) {
            case VehicleActivityType.LAYOVER:
                activityTypeColor = '#4d8af8';
                break;
            case VehicleActivityType.TRIPTRIP:
                activityTypeColor = '#a7a7a7';
                break;
            case VehicleActivityType.PREPIN:
            case VehicleActivityType.PREPOUT:
                activityTypeColor = '#d4d4d4';
                break;
        }
        return activityTypeColor;
    }

    // For know only return the exact string
    public static getString(type: VehicleActivityType): string {
       return type || '';
    }
}
